<template>
  <div class="main-content" id="main-content" :style="mainContentViewHeight">
    <iframe  id="track_card" :src="iframeUrl" ref="iframe"  width="100%" :height="tableMaxHeight" frameborder="0"></iframe>
  </div>
</template>

<script>

export default {
  props: ['mainContentViewHeight'],
  components: {

  },
  data() {
    return {
      url:"",
      tableMaxHeight: document.documentElement.clientHeight - 165 ,
      serverIp:"",
      iframeUrl:"",
    };
  },
  created() {
    this.getThirdConfig()
  },
  activated() {

  },
  methods: {
    getThirdConfig(){
      // 查询iframe Ip地址
      this.$http.get('/evalCardBrands/sysEvalCardBrands/getThirdConfig?type=2').then(res => {
        // console.log(this.$refs.iframe,`${res.data.data.url}/localsense/#/index/locmonitor/locmange/overview`);
        this.$refs.iframe.src=`${res.data.data.url}/localsenseadmin/#/basic/bindCard`;
        const iframeViewer = document.getElementById("track_card")
        iframeViewer.onload = function(){
          iframeViewer.contentWindow.postMessage({
            token: res.data.data.token,
            username: res.data.data.username,
            initConfig: {
                mapBgColor: "#ffffff"
            }
          },"*")
          iframeViewer.contentWindow.postMessage({
            type: "overview-highlight",
            value: 1
          })
        };
      })
    }
  },
};
</script>
<style scoped>
#main-content{
  margin-left: -24px !important;
  margin-right: -24px !important;
  margin-bottom: -24px !important;
}
</style>